import React, { useState, useEffect } from 'react';
import AppFixedHeader from '../../containers/AppFixedHeader';
import AppHelmet from '../AppHelmet';
import MapPageHero from './MapPageHero';
import MapPageIntro from './MapPageIntro';
import MapPageCategoryFilter from './MapPageCategoryFilter';
import MapPageProjectSnapshots from './MapPageProjectSnapshots';
import CepMap from './CEPMap';
import MapPageRelatedMaterials from '../../containers/MapPageRelatedMaterials';
import MapPageMethodology from './MapPageMethodology';

const MapPage = ({ content, recentSnapshots, related, energyTechnology }) => {
  const [projectModal, setProjectModal] = useState(null);
  const [selectedCategoryFilter, setSelectedCategoryFilter] = useState('');
  const [selectedEnergyTechnologyEntry, setSelectedEnergyTechnologyEntry] = useState(null);
  const [projectSnapshots, setProjectSnapshots] = useState([]);
  const [technologyPages, setTechnologyPages] = useState({});
  const snapshotIds = {};

  recentSnapshots.forEach((snapshot) => {
    snapshotIds[snapshot.id] = snapshot.title;
  });

  const onFilterCallback = (category) => {
    setSelectedCategoryFilter(category); // Update the selected category // technology in the parent component
  }

  useEffect(() => {
    const pages = {};

    energyTechnology.forEach((tech) => {
      if (tech.technologyPage.length) {
        pages[tech.technologyId] = tech.technologyPage[0].uri ? tech.technologyPage[0].uri : '';
      }
    });

    setTechnologyPages(pages);
  }, [energyTechnology]);

  useEffect(() => {
    setSelectedEnergyTechnologyEntry(energyTechnology.find(tech => parseInt(tech.technologyId, 10) === selectedCategoryFilter));
  }, [selectedCategoryFilter])

  return (
    <div className="MapPage">
      <AppHelmet
        title={content.title}
        description={content.seoDescription}
        image={content.seoImage.length ? content.seoImage[0].url : ''}
      />

      <AppFixedHeader />

      <MapPageHero content={content}/>
      <MapPageIntro content={content}/>
      <MapPageCategoryFilter
        energyTechnology={energyTechnology}
        onFilter={onFilterCallback}
        selectedCategoryFilter={selectedCategoryFilter}
        content={content}
      />
      <MapPageProjectSnapshots
        projectSnapshots={projectSnapshots}
        projectModal={projectModal}
        setProjectModal={setProjectModal}
        content={content}
        recentSnapshots={recentSnapshots}
        selectedCategoryFilter={selectedCategoryFilter}
        technologyPages={technologyPages}
      />
      <CepMap
        caption={content.caption}
        technologyPages={technologyPages}
        setProjectSnapshots={setProjectSnapshots}
        selectedCategoryFilter={selectedCategoryFilter}
        setSelectedCategoryFilter={setSelectedCategoryFilter}
        setProjectModal={setProjectModal}
        snapshotIds={snapshotIds}
        projectModal={projectModal}
      />

      <MapPageRelatedMaterials
        content={content}
        defaultItems={related}
        selectedEnergyTechnologyEntry={selectedEnergyTechnologyEntry}
      />

      <MapPageMethodology content={content}/>
    </div>
)}

export default MapPage;
